import { render, staticRenderFns } from "./TradeForm.vue?vue&type=template&id=53acf531"
import script from "./TradeForm.vue?vue&type=script&lang=js"
export * from "./TradeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports